import SiteHeaderLogo from './SiteHeader.Logo';
import SiteHeaderNavigation from './SiteHeader.Navigation';
import SiteHeaderSearchForm from './SiteHeader.SearchForm';
import SiteHeaderContent from './SiteHeader.Content';
import SiteHeaderToggler from './SiteHeader.Toggler';
import './_site-header.scss';

export default function SiteHeader({ children }) {
  return children;
}

SiteHeader.Logo = SiteHeaderLogo;
SiteHeader.Navigation = SiteHeaderNavigation;
SiteHeader.SearchForm = SiteHeaderSearchForm;
SiteHeader.Content = SiteHeaderContent;
SiteHeader.Toggler = SiteHeaderToggler;
